"use client";

import { useEffect, useRef } from "react";
import { useInhomzTrack } from "../../_hooks/useInhomzTrack";

// Fires once on mount; analytics-context queues it for CleverTap if the SDK
// is still loading. Server pages render this.
export default function PageViewTracker({ event, properties }) {
  const track = useInhomzTrack();
  const hasFired = useRef(false);

  useEffect(() => {
    if (hasFired.current) return;
    hasFired.current = true;
    track(event, properties);
  });

  return null;
}
